export default __webpack_public_path__ + "static/media/clothes-9.f1dee32b.svg";